const sliderItems = {
  'sliderItems-1-title-a': 'Como un carrito móvil de helados en el Rin',
  'sliderItems-1-title-b': 'y como heladería en Westfeld en Basilea',
  'sliderItems-2-title': 'Sobre nosotros',
  'sliderItems-3-title': 'Nuestra oferta',
  'sliderItems-4-title': 'Catering'
};

export default sliderItems;
